import "./index.css";
import React, { useState } from "react";
import { allUsersTable, fixedColumnsTitle } from "./model";
import { UserListController } from "./controller";
import { AuthZTable, defaultPageSize, defaultPageSizeOptions } from "../../../components/authZTable";
import { ColumnSelectPaginationPortal } from "../../../components/authZTable/column-select-pagination-portal";
import { MultiSelect } from "../../../components/multiSelect";
import { sendTableEvent, sendUserEvent, TableAction, UserAction } from "../../../components/matomoClient";
import { Routes } from "../../../common/Routes";
import { LinkSpan } from "../../../components/linkSpan";

export const UserList = () => {
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(defaultPageSize);
  const [searchFilter, setSearchFilter] = useState({});

  const [userQuery, setUserQuery] = useState({});
  const [sorter, setSorter] = useState({});

  const disableSortTitle = ["Projects", "Accounts"];
  const filterTitle = ["Status"];
  const narrowTitle = ["Emp ID", "Home Country", "Working Country", "Department Code", "Status"];
  const getWidth = (title) => {
    if (narrowTitle.includes(title)) {
      return 150;
    } else {
      return 200;
    }
  };

  const {
    data,
    columns,
    totalElements,
    canViewAllUsers,
    isLoading,
    selectedColumns,
    totalColumns,
    setSelectedColumns,
  } = UserListController(page, size, userQuery, sorter);

  let modifiedColumns = columns?.map((column) => {
    let { title, render, tableFilter, ...restKeys } = column;
    if (fixedColumnsTitle.includes(title)) {
      render = (text, { key: id }) => (
        <>
          <LinkSpan
            to={`${Routes.Users.usersList.path}/view/${id}`}
            text={text}
            matomoFn={() => {
              sendUserEvent(UserAction.UserDetails);
            }}
          />
        </>
      );
      restKeys = {
        ...restKeys,
        fixed: "left",
      };
    }

    if(!canViewAllUsers) {
      restKeys = {
        ...restKeys,
        filterEnabled: false,
        searchEnabled: false,
        sortEnabled: false,
      }
    }else {
      if (filterTitle.includes(title)) {
        restKeys = {
          ...restKeys,
          filters: tableFilter,
          filterMultiple: false,
          searchEnabled: false,
          sortEnabled: false,
          filterEnabled: true,
        };
      }

      if (disableSortTitle.includes(title)) {
        restKeys = {
          ...restKeys,
          filters: tableFilter,
          searchEnabled: true,
          sortEnabled: false,
          filterEnabled: false,
        };
      }

      if (restKeys.sortEnabled !== false) {
        restKeys = {
          ...restKeys,
          sorter: () => {
          },
        };
      }

      if (column.dataIndex !== "status") {
        restKeys = {
          ...restKeys,
          searchEnabled: true,
        };
      }
    }

    if (typeof render == "function") {
      return { ...restKeys, width: getWidth(title), title: title, render: render };
    } else {
      return { ...restKeys, width: getWidth(title), title: title };
    }
  });


  modifiedColumns = modifiedColumns?.filter(({ title }) => {
    return (
      selectedColumns.includes(title) ||
      !totalColumns.includes(title) ||
      fixedColumnsTitle.includes(title)
    );
  });


  const onPageChange = (current) => {
    setPage(current);
  };

  function changePageSize(size) {
    setSize(size);
  }

  function onChange(filters, sorter) {
    if (filters) {
      let employeeId = filters.employeeId != null ? filters.employeeId[0] : "";
      let fullName = filters.fullName != null ? filters.fullName[0] : "";
      let email = filters.email != null ? filters.email[0] : "";
      let jobProfile = filters.jobProfile != null ? filters.jobProfile[0] : "";
      let homeOffice = filters.homeOffice != null ? filters.homeOffice[0] : "";
      let homeCountry = filters.homeCountry != null ? filters.homeCountry[0] : "";
      let workingOffice = filters.workingOffice != null ? filters.workingOffice[0] : "";
      let workingOfficeCountry =
        filters.workingOfficeCountry != null ? filters.workingOfficeCountry[0] : "";
      let departmentCode = filters.departmentCode != null ? filters.departmentCode[0] : "";
      let department = filters.department != null ? filters.department[0] : "";
      let primaryOrganizationalHome =
        filters.primaryOrganizationalHome != null ? filters.primaryOrganizationalHome[0] : "";
      let status = filters.status != null && filters.status.length === 1 ? filters.status[0] : "";
      let projects = filters.projects != null ? filters.projects[0] : "";
      let accounts = filters.accounts != null ? filters.accounts[0] : "";
      setUserQuery({
        ...userQuery,
        employeeId: employeeId,
        fullName: fullName,
        email: email,
        jobProfile: jobProfile,
        homeOffice: homeOffice,
        homeCountry: homeCountry,
        workingOffice: workingOffice,
        workingOfficeCountry: workingOfficeCountry,
        departmentCode: departmentCode,
        department: department,
        primaryOrganizationalHome: primaryOrganizationalHome,
        status: status,
        projects: projects,
        accounts: accounts,
      });
    }

    if (sorter?.columnKey) {
      const sortColumnKey = (sorter?.order) ? sorter.columnKey : null;

      setSorter({
        sortField: sortColumnKey,
        sortDirection: sorter?.order,
      });
    }
  }

  function onFilterChange(pagination, filters, sorter) {
    if (pagination === null) setPage(1);
    const updatedFilters = {
      ...searchFilter,
      ...filters,
    };
    onChange(updatedFilters, sorter);
    setSearchFilter(updatedFilters);
  }

  function onCustomFilterAndCustomSortChange(filters, sorter) {
    const updatedFilters = {
      ...searchFilter,
      ...filters,
    };
    onChange(updatedFilters, sorter);
    setSearchFilter(updatedFilters);
  }

  return (
    <div style={{ marginTop: "1rem" }}>
      <AuthZTable
        id={allUsersTable.id}
        rowKey={"key"}
        columns={modifiedColumns}
        dataSource={data}
        loading={isLoading}
        pagination={{
          showSizeChanger: true,
          showQuickJumper: true,
          pageSize: size,
          pageSizeOptions: defaultPageSizeOptions,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          current: page,
          total: totalElements,
          onShowSizeChange: (current, pageSize) => changePageSize(pageSize, current),
          onChange: (current) => onPageChange(current),
        }}
        scroll={{ x: "max-content", y: "calc(100vh - 380px)" }}
        onChange={onFilterChange}
        onCustomFilterAndCustomSortChange={onCustomFilterAndCustomSortChange}
        isFilteredOrSortedInBackend={true}
      />
      <ColumnSelectPaginationPortal id={allUsersTable.id}>
        <MultiSelect
          placeHolder={"Select Columns"}
          options={totalColumns.filter((text) => !fixedColumnsTitle.includes(text))}
          selected={selectedColumns.filter((text) => !fixedColumnsTitle.includes(text))}
          onSelected={(value) => {
            setSelectedColumns(value);
            sendTableEvent(TableAction.SelectColumn, value);
          }}
          pinned={fixedColumnsTitle}
        />
      </ColumnSelectPaginationPortal>
    </div>
  );
};
